export default "__VITE_ASSET__BbjHJwv9__"